import React from 'react'
import ExpertDetailsComp from '../components/ExpertDetails';
import { useParams } from "react-router-dom";

const ExpertDetails = () => { 
    let { id } = useParams();
    return (
        <div style={{minHeight:"100vh"}}>
            <ExpertDetailsComp id={id}/>
        </div>
    )
}

export default ExpertDetails